import React, { useCallback, useEffect, useRef, useState } from 'react'
import { AlertType, Cidade, Clientes, Estado, InputsRefs, KEY_CODE_ESCAPE, Usuarios, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho } from '../../Utils/Types'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { DataSearch, SearchBox } from '../SearchBox/SearchBox'
import { ClientesService } from '../../Pages/Clientes/ClientesService'
import InputMask from 'react-input-mask'
import { Funcoes } from '../../Utils/Funcoes'
import { MdPersonSearch } from 'react-icons/md'
import { VendaAttribute, VendasService } from '../../Pages/Vendas/vendasService'

type Props = {
    idVenda: string,
    visible: boolean
    loading?: boolean
    identificarConsumidorEvent: (dadosConsumidor: any) => void
    closeModalEvent: () => void
}

interface Estados {
    [sigla: string]: number
}

interface DadosCliente {
    idCli: number
    nomeCliCadastrado: string
    nomeCliNaoCadastrado: string
    docCli: string
    logradouroCli: string
    bairroCli: string
    numeroCli: string
    cepCli: string
    complementoCli: string
    idUfCli: number,
    idCityCli: number
    obsCli: string
}

export const ModalIdentificarClienteFecharVenda = React.memo(({ idVenda, visible, loading, closeModalEvent, identificarConsumidorEvent }: Props) => {

    // -----------------------------------------------
    // ----------------- SEM USO ---------------------
    // -----------------------------------------------
    //const [clientes, setClientes] = useState<Clientes[]>([])
    //const [loadingConsultaCEP, setLoadingConsultaCEP] = useState<boolean>(false)
    //const [listaTempCli, setListaTempCli] = useState<DadosCliente[]>([])


    // -----------------------------------------------
    // ------------------ ATRIBUTOS ------------------
    // -----------------------------------------------
    const [attributes, setAttributes] = useState<VendaAttribute>()

    const [descCli, setDescCli] = useState("")
    const [nomeCli, setNomeCli] = useState("")
    const [doc, setDoc] = useState("")
    const [logradouro, setLogradouro] = useState("")
    const [bairro, setBairro] = useState("")
    const [numero, setNumero] = useState("")
    const [cep, setCep] = useState("")
    const [complemento, setComplemento] = useState("")
    const [obs, setObs] = useState("")

    // CIDADE
    const [cidade, setCidade] = useState<Cidade[]>([])
    const [idCity, setIdCity] = useState(0)

    // ESTADO
    const [uf, setUf] = useState<Estado[]>([])
    const [idUf, setIdUf] = useState(0)
    const [siglaUf, setSiglaUf] = useState("")

    // CLIENTE
    const [clientesList, setClientesList] = useState<Clientes[]>([])
    const [idCliente, setIdCliente] = useState(0)

    // VENDEDOR
    const [usuariosDefault, setUsuariosDefault] = useState<Usuarios[]>([])
    const [usuarios, setUsuarios] = useState<DataSearch[]>([])
    const [idVendedor, setIdVendedor] = useState(0)
    const [nomeVendedor, setNomeVendedor] = useState("")

    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [visibleMsg, setVisibleMsg] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")


    // -----------------------------------------------
    // ---------- LOADING -----------------
    // -----------------------------------------------
    const [loadingConsultaCliente, setLoadingConsultaCliente] = useState<boolean>(false)
    const [loadingBt, setLoadingBt] = useState<boolean>(false)

    // -----------------------------------------------
    // ------------------ SEARCHBOX ------------------
    // -----------------------------------------------
    const [visibleSearchBoxCliente, setVisibleSearchBoxCliente] = useState<boolean>(false)
    const [visibleSearchBoxUF, setVisibleSearchBoxUF] = useState<boolean>(false)
    const [visibleSearchBoxCity, setVisibleSearchBoxCity] = useState<boolean>(false)
    const [visibleSearchBoxVendedor, setVisibleSearchBoxVendedor] = useState<boolean>(false)

    //------------------------------------------------------------------- ATRIBUTES E USEEFFECT ----------------------------------------------------------------------------------- ||
    const estados: Estados = {
        'AC': 1,
        'AL': 2,
        'AM': 3,
        'AP': 4,
        'BA': 5,
        'CE': 6,
        'DF': 7,
        'ES': 8,
        'GO': 9,
        'MA': 10,
        'MG': 11,
        'MS': 12,
        'MT': 13,
        'PA': 14,
        'PB': 15,
        'PE': 16,
        'PI': 17,
        'PR': 18,
        'RJ': 19,
        'RN': 20,
        'RO': 21,
        'RR': 22,
        'RS': 23,
        'SC': 24,
        'SE': 25,
        'SP': 26,
        'TO': 27
    }

    // Função para obter o valor numérico a partir da sigla do estado
    const obterValorNumerico = (sigla: string): number => {
        return estados[sigla] || 0 // Retorna 0 se a sigla não estiver mapeada
    }

    const getAttributes = async () => {

        setLoadingConsultaCliente(true)

        try {

            const attr = await VendasService.GetAttributes(idVenda)

            let newUsuariosList: DataSearch[] = attr.data.usuarios.map((item: any) => { return { id: item.id, description: item.nome } })
            setUsuarios(newUsuariosList)

            setAttributes(attr.data)
            setClientesList(attr.data.clientes)
            setUf(attr.data.estados)
            setCidade(attr.data.cidades)
            setUsuariosDefault(attr.data.usuarios)
            setIdVendedor(attr.data.identificacao.idVendedor)

            const vendedor = attr.data.usuarios.find((user: any) => user.id === attr.data.identificacao.idVendedor)

            if (vendedor) {
                setNomeVendedor(vendedor?.nome)
            }

            if (attr?.data?.identificacao?.idCliente > 0) {
                const identificacao = attr.data.identificacao;

                setNomeCli(identificacao?.nomeConsumidor || '');
                setDoc(Funcoes.FormatDoc(identificacao?.docConsumidor) || '');

                setCep(identificacao?.cepConsumidor?.toString() || '');
                setLogradouro(identificacao?.ruaConsumidor || '');
                setBairro(identificacao?.bairroConsumidor || '');
                setNumero(identificacao?.numeroConsumidor || '');
                setIdCity(identificacao?.idCidade || 0);

                const valorNumerico = obterValorNumerico(identificacao?.uf || '');
                setIdUf(valorNumerico);
                setSiglaUf(identificacao?.uf || '');
                setIdCliente(identificacao?.idCliente || '');
                setObs(identificacao?.obs || '');
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Ocorreu um erro ao buscar os dados`)

        } finally {
            setLoadingConsultaCliente(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 0)
        }
    }

    useEffect(() => {

        if (visible) {

            getAttributes()

            let modal = document.getElementById('modal_identificar_cliente_fechar_venda')
            let modalContent = document.getElementById('modal_content_identificar_cliente_fechar_venda')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-500px]')
                    modalContent.classList.add('mt-24')
                }
            }

        } else {

            setVisibleMsg(false)

            let modal = document.getElementById('modal_identificar_cliente_fechar_venda')
            let modalContent = document.getElementById('modal_content_identificar_cliente_fechar_venda')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-500px]')
                    modalContent.classList.remove('mt-24')
                }
            }

            searchBoxFocus()

            setIdCliente(0)
            setNomeCli("")
            setDoc("")
            setLogradouro("")
            setBairro("")
            setNumero("")
            setCep("")
            setComplemento("")
            setObs("")
            setIdCity(0)
            setIdUf(0)

        }

        const handleKeyPressESC = (event: any) => {
            if (event.code === KEY_CODE_ESCAPE) {

                if (visible) {

                    if (closeModalEvent) {
                        closeModalEvent()
                    }
                }
            }
        }

        document.addEventListener('keydown', handleKeyPressESC)

        return () => {
            document.removeEventListener('keydown', handleKeyPressESC)

        }

    }, [visible])

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    const identificarConsumidorVenda = async () => {

        setVisibleMsg(false)

        try {

            if (visible) {

                let xDoc = ""
                if (doc) {
                    xDoc = Funcoes.onlyNumber(doc)
                }

                let newCli = null

                if (idCliente === 0) {

                    let newCliente: any = {
                        nome: descCli,
                        endereco: logradouro,
                        bairro: bairro,
                        numero: numero,
                        cep: cep,
                        id_cidade: idCity,
                        uf: siglaUf,
                        tipo_pessoa: xDoc.length === 14 ? "J" : "F",
                        cnpj_cpf: xDoc,
                        ie_rg: "isento",
                        complemento: "",
                        observacao: obs,
                        ativo: "S"
                    }

                    newCli = await ClientesService.Save(newCliente)

                    if (newCli.error) {

                        setVisibleMsg(true)
                        setMessageType("DANGER")
                        setMessage(`Não foi possivel identificar o consumidor`)

                        const timer = setTimeout(() => {
                            Inputfocus()
                            clearTimeout(timer)
                        }, 0)

                    }
                }

                let itens: any = {
                    id_consumidor: newCli ? newCli.id : idCliente,
                    nome_consumidor: nomeCli || descCli,
                    doc: xDoc,
                    logradouro: logradouro,
                    bairro: bairro,
                    numero: numero,
                    complemento: complemento,
                    uf: siglaUf,
                    id_cidade: idCity,
                    observacao: obs,
                    cep: cep,
                    idVendedor: idVendedor,
                    nomeVendedor: nomeVendedor
                }

                if (itens.id_consumidor > 0) {
                    identificarConsumidorEvent(itens)
                }
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Ocorreu um erro na identificação do consumidor`)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 0)
        }
    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("descCli_fecharVenda")
        inputElement?.focus()
    }

    //------------------------------------------------------------------- USUARIO ----------------------------------------------------------------------------------- ||
    const handlerClearUsuario = useCallback(() => {
        setUsuariosOriginal()
        setIdVendedor(0)

        setVisibleSearchBoxVendedor(false)
        boxFocusVendedor()
    }, [usuarios])

    const handleSetUsuario = useCallback((data: DataSearch) => {
        if (data) {
            setUsuariosOriginal()
            setIdVendedor(data.id)
            setNomeVendedor(data.description)
        }

        setVisibleSearchBoxVendedor(false)
        boxFocusVendedor()
    }, [usuarios])

    const setUsuariosOriginal = useCallback(() => {
        let newUsuariosList: any[] = [...usuariosDefault]
        newUsuariosList = usuariosDefault.map(item => { return { id: item.id, description: item.nome } })
        setUsuarios(newUsuariosList)
    }, [usuarios])

    const handleFilterUsuario = useCallback((descricao: string) => {
        if (descricao.trim() === "") {
            setUsuariosOriginal()
        } else {
            let newUsuariosList = usuariosDefault.filter(item => item.nome.toLocaleLowerCase().startsWith(descricao.toLocaleLowerCase()))
            let newUsuariosSearchList = newUsuariosList.map(item => { return { id: item.id, description: item.nome } })
            setUsuarios(newUsuariosSearchList)
        }
    }, [usuarios])


    //------------------------------------------------------------------- CLIENTE ----------------------------------------------------------------------------------- ||
    const handleClearClienteSelecionado = useCallback(() => {

        const newClienteList = [...attributes?.clientes || []]
        setClientesList(newClienteList)
        setIdCliente(0)

        setNomeCli("")
        setDoc("")
        setLogradouro("")
        setBairro("")
        setNumero("")
        setCep("")
        setComplemento("")
        setObs("")
        setIdCity(0)
        setIdUf(0)

        setVisibleSearchBoxCliente(false)
        boxFocusCliente()

    }, [attributes?.clientes])

    const handleFilterClienteClick = useCallback(async (description: string) => {

        if (description.trim() === "") {

            const newClienteList = [...attributes?.clientes || []]
            setClientesList(newClienteList || [])

        } else {

            const newClienteList = [...attributes?.clientes || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setClientesList(newClienteList || [])
        }

    }, [attributes?.clientes])

    const handleClienteSelectClick = useCallback(async (v: Clientes) => {

        setVisibleMsg(false)

        if (v.id > 0) {

            setLoadingConsultaCliente(true)
            const xId = v.id ? v.id.toString() : ""
            const resp = await ClientesService.Filter('', '', '', '', xId)

            if (resp.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(resp.msg || '')
                setLoadingConsultaCliente(false)

            } else {

                const valorNumerico = obterValorNumerico(resp.data[0]?.uf)

                setNomeCli(resp.data[0]?.nome || '')
                setDoc(Funcoes.FormatDoc(resp.data[0]?.cnpj_cpf) || '')
                setLogradouro(resp.data[0]?.endereco || '')
                setBairro(resp.data[0]?.bairro || '')
                setNumero(resp.data[0]?.numero?.toString() || "")
                setCep(resp.data[0]?.cep || '')
                setComplemento(resp.data[0]?.complemento || '')
                setObs(resp.data[0]?.observacao || '')
                setIdCity(resp.data[0]?.id_cidade || 0)
                setIdUf(valorNumerico)
                setarCidades(resp.data[0]?.uf || '')
                setSiglaUf(resp.data[0]?.uf || '')

                setIdCliente(v.id)
                setLoadingConsultaCliente(false)

                //const newClienteList = [...clientes || []]
                //setClientesList(newClienteList)
                //setDescCli("")

            }

        } else {
            setNomeCli('')
            setDoc('')
            setLogradouro('')
            setBairro('')
            setNumero('')
            setCep('')
            setComplemento('')
            setObs('')
            setIdCity(0)
            setIdUf(0)
            setarCidades('')
            setSiglaUf('')
            setIdCliente(0)
        }

        setVisibleSearchBoxCliente(false)
        boxFocusCliente()

    }, [attributes?.clientes])

    //------------------------------------------------------------------- INPUTS ----------------------------------------------------------------------------------- ||
    const handleDescCli = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescCli(e.target.value)
    }

    const handleDoc = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        const numericValue = Funcoes.onlyNumber(value.replace(/[.-]/g, ''))

        setDoc(value)

        if (numericValue.length === 11 || numericValue.length === 14) {
            const formattedDoc = Funcoes.FormatDoc(numericValue)
            setDoc(formattedDoc || value)
        }
    }

    const handleLogradouro = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLogradouro(e.target.value)
    }

    const handleBairro = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBairro(e.target.value)
    }

    const handleNumero = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumero(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleCep = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replaceAll('_', '').replaceAll('-', '')
        setCep(inputValue)

        if (e.target.value && Funcoes.onlyNumber(e.target.value).length === 8) {

            handleConsultaCEP(e.target.value)

        } else if (e.target.value && Funcoes.onlyNumber(e.target.value).length === 0) {

            setNomeCli("")
            setDoc("")
            setLogradouro("")
            setBairro("")
            setNumero("")
            setCep("")
            setComplemento("")
            setObs("")
            setIdCity(0)
            setIdUf(0)

        }
    }

    const handleConsultaCEP = async (cep: string) => {

        setLoadingConsultaCliente(true)

        try {

            const dadosCEP = await Funcoes.ConsultaCEP(cep)

            if (dadosCEP.error) {

                setIdCity(0)
                setIdUf(0)
                setBairro('')
                setComplemento('')
                setLogradouro('')

            } else {

                updateUfList()

                const estado = [...attributes?.estados || []].filter((item) => item.sigla === dadosCEP.data.uf)
                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                    setarCidades(estado[0].sigla)
                    setSiglaUf(estado[0].sigla)
                }

                const cidade = [...attributes?.cidades || []].filter((item) => item.id === dadosCEP.data.ibge)
                if (cidade && cidade.length > 0) {
                    setIdCity(cidade[0].id)
                }

                setBairro(dadosCEP.data.bairro)
                setComplemento(dadosCEP.data.complemento)
                setLogradouro(dadosCEP.data.logradouro)
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Houve um erro ao consultar o CEP`)

        } finally {
            setLoadingConsultaCliente(false)
        }
    }

    const handleComplemento = (e: React.ChangeEvent<HTMLInputElement>) => {
        setComplemento(e.target.value)
    }

    const handleObs = (e: React.ChangeEvent<HTMLInputElement>) => {
        setObs(e.target.value)
    }

    //------------------------------------------------------------------- CIDADE ----------------------------------------------------------------------------------- ||
    const handleClearCidadeSelecionada = useCallback(() => {
        setIdCity(0)
        setarCidades(siglaUf)

        setVisibleSearchBoxCity(false)
        boxFocusCidade()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
    }, [siglaUf, uf])

    const handleFilterCidadeClick = useCallback(async (description: string) => {

        if (description.trim() === "") {

            /*
            const newCidadeList = [...attributes?.cidades || []]
            setCidade(newCidadeList)
            */

            setarCidades(siglaUf)

        } else {
            const newCidadeList = [...attributes?.cidades || []].filter((item) => {

                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()) &&
                    item.uf === siglaUf

                /*
                if (idUf > 0) {

                    return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()) &&
                        item.uf === siglaUf

                } else {

                    return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
                }
                    */

            })

            setCidade(newCidadeList || [])
        }

    }, [siglaUf, uf])

    const handleCidadeSelectClick = useCallback((v: Cidade) => {
        if (v) {
            setIdCity(v.id)
            setarCidades(siglaUf)
        }

        setVisibleSearchBoxCity(false)
        boxFocusCidade()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */

    }, [siglaUf, uf])

    const setarCidades = async (uf: string) => {
        const citys = await attributes?.cidades.filter(item => item.uf === uf)
        setCidade(citys || [])
    }

    //------------------------------------------------------------------- ESTADO ----------------------------------------------------------------------------------- ||
    const handleClearUfSelecionada = useCallback(() => {
        setIdUf(0)
        setSiglaUf("")

        updateUfList()

        setCidade([])
        setIdCity(0)

        setVisibleSearchBoxUF(false)
        boxFocusUF()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
    }, [attributes?.estados])

    const handleFilterUfClick = useCallback(async (description: string) => {

        if (description.trim() === "") {
            updateUfList()

        } else {

            const newUfList = [...attributes?.estados || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setUf(newUfList || [])
        }

    }, [attributes?.estados])

    const handleUfSelectClick = useCallback((v: Estado) => {

        if (v.id > 0) {

            setIdUf(v.id)
            setSiglaUf(v.sigla)
            setarCidades(v.sigla)

        } else {
            setIdUf(0)
            setSiglaUf('')
            setarCidades('')
        }

        updateUfList()

        setIdCity(0)

        setVisibleSearchBoxUF(false)
        boxFocusUF()
    }, [attributes?.estados])

    const updateUfList = () => {
        const newUfList = [...attributes?.estados || []]
        setUf(newUfList)
    }

    // ---------------------------------------------------------------- FUNCOES DO TAB -----------------------------------------------------------------
    const inputsRefs: InputsRefs = {
        clienteNaoCadastrado: useRef(null),
        clienteCadastrado: useRef(null),
        cpfCnpj: useRef(null),
        cep: useRef(null),
        logradouro: useRef(null),
        bairro: useRef(null),
        numero: useRef(null),
        complemento: useRef(null),
        uf: useRef(null),
        cidade: useRef(null),
        vendedor: useRef(null),
        observacao: useRef(null),

    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && idCliente === 0 && !loadingConsultaCliente) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            setVisibleSearchBoxCliente(false)
            setVisibleSearchBoxUF(false)
            setVisibleSearchBoxCity(false)
            setVisibleSearchBoxVendedor(false)

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            if (nextIndex === 1) {
                setVisibleSearchBoxCliente(true)
                inputFocusCliente()
            }

            if (nextIndex === 8) {
                setVisibleSearchBoxUF(true)
                inputFocusUF()
            }

            if (nextIndex === 9) {
                setVisibleSearchBoxCity(true)
                inputFocusCidade()
            }

            if (nextIndex === 10) {
                setVisibleSearchBoxVendedor(true)
                inputFocusVendedor()
            }


            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()
        }
    }

    useEffect(() => {

        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && !loadingConsultaCliente) {

                event.preventDefault()

                const inputSearchCliente = document.getElementById('inputSearchBox-clienteFecharVenda') as HTMLInputElement
                const inputSearchUF = document.getElementById('inputSearchBox-ufFecharVenda') as HTMLInputElement
                const inputSearchCidade = document.getElementById('inputSearchBox-cidadeFecharVenda') as HTMLInputElement
                const inputSearchVendedor = document.getElementById('inputSearchBox-vendedorFecharVenda') as HTMLInputElement


                if (document.activeElement === inputSearchCliente) {

                    inputsRefs['cpfCnpj'].current?.focus()
                    setVisibleSearchBoxCliente(false)

                } else if (document.activeElement === inputSearchUF) {
                    clickSearchBoxCidade()
                    setVisibleSearchBoxUF(false)
                }
                else if (document.activeElement === inputSearchCidade) {
                    clickSearchBoxVendedor()
                    setVisibleSearchBoxCity(false)
                }
                else if (document.activeElement === inputSearchVendedor) {
                    inputsRefs['observacao'].current?.focus()
                    setVisibleSearchBoxVendedor(false)
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }

    }, [loadingConsultaCliente])

    const searchBoxFocus = () => {
        setVisibleSearchBoxCliente(false)
        setVisibleSearchBoxUF(false)
        setVisibleSearchBoxCity(false)
        setVisibleSearchBoxVendedor(false)
    }

    // CLIENTE
    const boxFocusCliente = () => {
        // Move o foco para o input correspondente à chave 'clienteCadastrado'.
        inputsRefs['clienteCadastrado'].current?.focus()
    }

    const clickSearchBoxCliente = useCallback(() => {
        setVisibleSearchBoxCliente((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxCity(false)
                setVisibleSearchBoxVendedor(false)
                setVisibleSearchBoxUF(false)
                inputFocusCliente()
            }
            return newState
        })

        boxFocusCliente()
    }, [])

    const inputFocusCliente = () => {
        let inputSearch = document.getElementById(`inputSearchBox-clienteFecharVenda`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // UF
    const boxFocusUF = () => {
        // Move o foco para o input correspondente à chave 'uf'.
        inputsRefs['uf'].current?.focus()
    }

    const clickSearchBoxUF = useCallback(() => {
        setVisibleSearchBoxUF((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxCity(false)
                setVisibleSearchBoxCliente(false)
                setVisibleSearchBoxVendedor(false)
                inputFocusUF()
            }
            return newState
        })

        boxFocusUF()
    }, [])

    const inputFocusUF = () => {
        let inputSearch = document.getElementById(`inputSearchBox-ufFecharVenda`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // CIDADE
    const boxFocusCidade = () => {
        // Move o foco para o input correspondente à chave 'cidade'.
        inputsRefs['cidade'].current?.focus()
    }

    const clickSearchBoxCidade = useCallback(() => {
        setVisibleSearchBoxCity((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxVendedor(false)
                setVisibleSearchBoxCliente(false)
                setVisibleSearchBoxUF(false)
                inputFocusCidade()
            }
            return newState
        })
        boxFocusCidade()
    }, [])

    const inputFocusCidade = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cidadeFecharVenda`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // VENDEDOR 
    const boxFocusVendedor = () => {
        // Move o foco para o input correspondente à chave 'vendedor'.
        inputsRefs['vendedor'].current?.focus()
    }

    const clickSearchBoxVendedor = useCallback(() => {
        setVisibleSearchBoxVendedor((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxCity(false)
                setVisibleSearchBoxCliente(false)
                setVisibleSearchBoxUF(false)
                inputFocusVendedor()
            }
            return newState
        })
        boxFocusVendedor()
    }, [])

    const inputFocusVendedor = () => {
        let inputSearch = document.getElementById(`inputSearchBox-vendedorFecharVenda`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    return (

        <div id="modal_identificar_cliente_fechar_venda" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_identificar_cliente_fechar_venda" className={`relative flex flex-col w-[90%] xl:w-[60%] h-[450px] bg-white dark:bg-slate-600 rounded-lg mt-[-500px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                {/* Header */}
                <div className={`absolute top-0 flex flex-row w-full h-[70px] items-center`}>

                    <div className={`w-[5%] flex items-center justify-center ml-4`}>

                        <div className={`flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                            <MdPersonSearch size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-100`} />
                        </div>

                    </div>

                    <div className={`w-[90%]`}>
                        <span className={`ml-2 text-lg text-slate-700 dark:text-slate-100`}>Identificar Cliente</span>
                    </div>

                </div>
                {/* Header */}

                {/* Body */}
                <div className={`absolute top-[70px] bottom-[60px] w-full pt-0`}>

                    <div className={`w-full grid gap-4 grid-cols-12 p-2`}>

                        <div className={`relative col-span-6`} >
                            <input ref={inputsRefs.clienteNaoCadastrado} onKeyDown={(e) => handleTabPress(e, 'clienteNaoCadastrado')} id='descCli_fecharVenda' className={`${classInput} ${classInputDark} ${idCliente === 0 ? `` : `opacity-70 cursor-not-allowed`}`} type='text' inputMode='text' maxLength={155} placeholder='' autoComplete='off' value={descCli} disabled={idCliente === 0 ? false : true} onFocus={searchBoxFocus} onChange={handleDescCli} />
                            <label htmlFor="descCli_fecharVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Cliente Não Cadastrado</label>
                        </div>

                        <div className={`relative col-span-6`}>

                            <div ref={inputsRefs['clienteCadastrado']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'clienteCadastrado')} />
                            <SearchBox
                                dataList={clientesList}
                                idRegistro={idCliente || undefined}
                                label='Cliente Cadastrado'
                                componentId='clienteFecharVenda'
                                visibleTAB={visibleSearchBoxCliente}
                                clearDataClick={handleClearClienteSelecionado}
                                setDataClick={handleClienteSelectClick}
                                filterDataClick={handleFilterClienteClick}
                                clicado={clickSearchBoxCliente}
                            />
                        </div>

                        <div className={`relative col-span-4`}>
                            <input ref={inputsRefs.cpfCnpj} onKeyDown={(e) => handleTabPress(e, 'cpfCnpj')} id='doc_fecharVenda' className={`${classInput} ${classInputDark} disabled:opacity-70 disabled:cursor-not-allowed`} type='text' inputMode='numeric' maxLength={18} placeholder='' autoComplete='off' value={doc} disabled={idCliente === 0 ? false : true} onFocus={searchBoxFocus} onChange={handleDoc} />
                            <label htmlFor="doc_fecharVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>CPF / CNPJ</label>
                        </div>

                        <div className={`relative col-span-2`}>
                            <InputMask ref={inputsRefs.cep} onKeyDown={(e) => handleTabPress(e, 'cep')} id="cep_fecharVenda" className={`${classInput} ${classInputDark} disabled:opacity-70 disabled:cursor-not-allowed`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={cep} disabled={idCliente === 0 ? false : true} onFocus={searchBoxFocus} onChange={handleCep} mask={'99999-999'} alwaysShowMask={true} />
                            <label htmlFor="cep_fecharVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>CEP</label>
                        </div>

                        <div className={`relative col-span-6`}>
                            <input ref={inputsRefs.logradouro} onKeyDown={(e) => handleTabPress(e, 'logradouro')} id='logradouro_fecharVenda' className={`${classInput} ${classInputDark} disabled:opacity-70 disabled:cursor-not-allowed`} type='text' inputMode='text' maxLength={100} placeholder='' autoComplete='off' value={logradouro} disabled={idCliente === 0 ? false : true} onFocus={searchBoxFocus} onChange={handleLogradouro} />
                            <label htmlFor="logradouro_fecharVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Logradouro</label>
                        </div>

                        <div className={`relative col-span-4`}>
                            <input ref={inputsRefs.bairro} onKeyDown={(e) => handleTabPress(e, 'bairro')} id='bairro_fecharVenda' className={`${classInput} ${classInputDark} disabled:opacity-70 disabled:cursor-not-allowed`} type='text' inputMode='text' maxLength={60} placeholder='' autoComplete='off' value={bairro} disabled={idCliente === 0 ? false : true} onFocus={searchBoxFocus} onChange={handleBairro} />
                            <label htmlFor="bairro_fecharVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Bairro</label>
                        </div>

                        <div className={`relative col-span-2`}>
                            <input ref={inputsRefs.numero} onKeyDown={(e) => handleTabPress(e, 'numero')} id='numero_fecharVenda' className={`${classInput} ${classInputDark} disabled:opacity-70 disabled:cursor-not-allowed`} type='text' inputMode='numeric' maxLength={20} placeholder='' autoComplete='off' value={numero} disabled={idCliente === 0 ? false : true} onFocus={searchBoxFocus} onChange={handleNumero} />
                            <label htmlFor="numero_fecharVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Número</label>
                        </div>

                        <div className={`relative col-span-3`}>
                            <input ref={inputsRefs.complemento} onKeyDown={(e) => handleTabPress(e, 'complemento')} id='complemento_fecharVenda' className={`${classInput} ${classInputDark} disabled:opacity-70 disabled:cursor-not-allowed`} type='text' inputMode='text' placeholder='' autoComplete='off' value={complemento} disabled={idCliente === 0 ? false : true} onFocus={searchBoxFocus} onChange={handleComplemento} />
                            <label htmlFor="complemento_fecharVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Complemento</label>
                        </div>

                        <div className={`relative col-span-3`}>

                            <div ref={inputsRefs['uf']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'uf')} />
                            <SearchBox
                                dataList={uf}
                                idRegistro={idUf}
                                disabled={idCliente === 0 ? false : true}
                                label='Estado'
                                componentId='ufFecharVenda'
                                visibleTAB={visibleSearchBoxUF}
                                clearDataClick={handleClearUfSelecionada}
                                setDataClick={handleUfSelectClick}
                                filterDataClick={handleFilterUfClick}
                                clicado={clickSearchBoxUF}
                            />
                        </div>

                        <div className={`relative col-span-6`} >

                            <div ref={inputsRefs['cidade']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'cidade')} />
                            <SearchBox
                                dataList={cidade}
                                idRegistro={idCity}
                                disabled={idCliente === 0 ? false : true}
                                label='Cidade'
                                componentId='cidadeFecharVenda'
                                visibleTAB={visibleSearchBoxCity}
                                clearDataClick={handleClearCidadeSelecionada}
                                setDataClick={handleCidadeSelectClick}
                                filterDataClick={handleFilterCidadeClick}
                                clicado={clickSearchBoxCidade}
                            />
                        </div>

                        <div className={`relative col-span-6`}>

                            <div ref={inputsRefs['vendedor']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'vendedor')} />
                            <SearchBox
                                dataList={usuarios}
                                idRegistro={idVendedor}
                                label='Vendedor'
                                componentId='vendedorFecharVenda'
                                visibleTAB={visibleSearchBoxVendedor}
                                setDataClick={handleSetUsuario}
                                clearDataClick={handlerClearUsuario}
                                filterDataClick={handleFilterUsuario}
                                clicado={clickSearchBoxVendedor}
                            />
                        </div>

                        <div className={`relative col-span-12`}>
                            <input ref={inputsRefs.observacao} onKeyDown={(e) => handleTabPress(e, 'observacao')} id='obs_fecharVenda' className={`${classInput} ${classInputDark} disabled:opacity-70 disabled:cursor-not-allowed`} placeholder='' value={obs} autoComplete='off' disabled={idCliente === 0 ? false : true} onFocus={searchBoxFocus} onChange={handleObs} />
                            <label htmlFor="obs_fecharVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                        </div>

                    </div>

                </div>

                {loadingConsultaCliente &&

                    <div className={`absolute top-[70px] bottom-[60px] w-full pt-4 bg-slate-300 dark:bg-slate-700 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                {/* Body */}

                {/* Footer */}
                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        onClick={closeModalEvent} disabled={loadingConsultaCliente}
                        className={`${classbtColunasVermelho} max-w-[150px]`}>
                        CANCELAR
                    </button>

                    <button
                        onClick={identificarConsumidorVenda} disabled={loadingConsultaCliente}
                        className={`${classbtAzul} ${classBt} max-w-[150px]`}>

                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? `CONFIRMAR` : "AGUARDE"}

                    </button>

                </div>
                {/* Footer */}

            </div>

        </div>
    )
})